import { render } from "./ApprovalDetail.vue?vue&type=template&id=6e5a36f8"
import script from "./ApprovalDetail.vue?vue&type=script&lang=js"
export * from "./ApprovalDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__